import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ApiService } from '../services/api.service';
import { Store } from '@ngxs/store';
import { AuthState } from '../states/auth.state';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserActivityResolver {
  constructor(
    private store: Store,
    private api: ApiService
  ) {}

  async resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    try {
      // Id uit de JWT: UsersState.me is direct na inloggen nog niet geladen
      const userId = this.store.selectSnapshot(AuthState.currentUser)?.sub;

      if (!userId) {
        return;
      }

      firstValueFrom(this.api.logActivity(userId));
      return true;
    } catch (err) {
      console.error(err);
      return true;
    }
  }
}
